<ui-web-page-title pageTitle="Testimonies" *ngIf="showPageTitle" class="container-fluid ui-web-page-title"></ui-web-page-title>

<div class="container-fluid ui-web-testimonies">
    <div class="container">
        <div class="row ui-web-testimonies__content">
            @for(item of testimoniesToShow; track item; let count = $index) {
                <div class="col-lg-4 ui-web-testimonies__card-container">
                    <div class="ui-web-testimonies__content__card">
                        <img src="assets/img/drc.png" alt="Testimony Logo"/>
                        <h2>{{ item.testimony_info.fName.toUpperCase() }}&nbsp;{{ item.testimony_info.lName.toUpperCase() }}</h2>
                        <h3 class="uppercase-text">{{ item.testimony_info.subject }}</h3>
                        <p class="testimony" [id]="'message-' + count">{{ getShortMessage(item.testimony_info.message) }}</p>
                        <div class="button-container">
                            <div class="button" *ngIf="buttonState[count] && showReadMoreButton(item.testimony_info.message)" 
                                 type="button"
                                 (click)="onReadMoreClick(count, item.testimony_info.message)">
                                Read More
                                <span class="icon-arrow-down-circle icon"></span>
                            </div>
                            <div class="button" *ngIf="!buttonState[count] && showReadMoreButton(item.testimony_info.message)" 
                                 type="button" 
                                 (click)="onReadLessClick(count, item.testimony_info.message)">
                                Read Less
                                <span class="icon-arrow-up-circle icon"></span>
                            </div>
                        </div>
                    </div>
                </div>
            } @empty {
                <div class="col-12">
                    <div class="no-content-message">
                        <span class="icon-info icon"></span>
                        No Testimonies Found.
                    </div>
                </div>
            }
        </div>
    </div>
    <div class="container ui-web-testimonies__pagination" *ngIf="showPagination">
        <div class="row">
            <div class="col-12 ui-web-testimonies__pagination__content">
                <button type="button" class="icon-chevrons-left icon" (click)="onPaginate('F')" 
                        [disabled]="(disableFirstPrevButton())? 'disabled': ''"></button>
                <button type="button" class="icon-chevron-left icon" (click)="onPaginate('P')" 
                        [disabled]="(disableFirstPrevButton())? 'disabled': ''"></button>
                 <div class="pageCount">
                     <span class="currentPage">{{ currentPage }}</span>
                     <span>/</span>
                     <span>{{ totalPages }}</span>
                 </div>
                <button type="button" class="icon-chevron-right icon" (click)="onPaginate('N')"
                        [disabled]="(disableNextLastButton())? 'disabled': ''"></button>
                <button type="button" class="icon-chevrons-right icon" (click)="onPaginate('L')"
                        [disabled]="(disableNextLastButton()? 'disabled': '')"></button>
            </div>
        </div>
    </div>
</div>

